import { api } from "@/lib/api-client"

// =============================================================================
// LLM Pool API
// =============================================================================

export type LLMPoolEndpoint = {
  id: string
  service_name: string
  subscription_id: string
  region: string
  enabled: boolean
}

export type LLMPoolConfig = {
  endpoints: LLMPoolEndpoint[]
  cooldown_seconds: number
  consecutive_failures_threshold: number
}

export type LLMPoolStatsEndpoint = {
  id: string
  service_name: string
  region: string
  total_requests: number
  total_failover_requests: number
  errors: number
  rate_limited_count: number
  in_cooldown: boolean
}

export type LLMPoolStatsResponse = {
  enabled: boolean
  endpoint_count?: number
  endpoints: LLMPoolStatsEndpoint[]
}

export async function getLLMPoolConfig(): Promise<LLMPoolConfig> {
  const response = await api.get("/admin/llm-pool/config")
  return response.data || response
}

export async function updateLLMPoolConfig(
  config: Partial<LLMPoolConfig>
): Promise<{ success: boolean; config: LLMPoolConfig }> {
  const response = await api.put("/admin/llm-pool/config", config)
  return response.data || response
}

export async function refreshLLMPoolConfig(): Promise<{
  success: boolean
  message: string
  endpoint_count: number
}> {
  const response = await api.post("/admin/llm-pool/refresh")
  return response.data || response
}

export async function getLLMPoolStats(): Promise<LLMPoolStatsResponse> {
  const response = await api.get("/admin/llm-pool/stats")
  return response.data || response
}
